import React from 'react';
import novaImage from '../Nova_02.png';

const Nova02Image = ({height}) => <img style={{height: height || 180}} src={novaImage}></img>;

export default Nova02Image;
